import { render } from "./BoosterBlock.vue?vue&type=template&id=3dc8033c"
import script from "./BoosterBlock.vue?vue&type=script&lang=js"
export * from "./BoosterBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__